module.exports = __webpack_public_path__ + "static/media/reference-slider-26.cab3c01f.jpg";